/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailNotificationUserDTO { 
    /**
     * User\'s email
     */
    email?: string;
    /**
     * Flag indicating whether notification was read or not
     */
    read?: boolean;
}

export class ClsEmailNotificationUserDTO { 
    /**
     * User\'s email
     */
    email?: string = undefined;
    /**
     * Flag indicating whether notification was read or not
     */
    read?: boolean = undefined;
}

